import React, { PureComponent } from "react";
import { Modal, Icon, Button } from "semantic-ui-react";
import { getLabel } from "../../constants/Strings";
import styles from "./ErrorDialog.module.css";

class ErrorDialog extends PureComponent {
	render() {
		const { error, title, text, onPress } = this.props;
		return (
			<Modal open={error} onClose={onPress}>
				<Modal.Content className={styles.content}>
					<Icon name={"warning sign"} size={"big"} color={"red"} />
					<div className={styles.titleText}>{title}</div>
					<p className={styles.text}>{text}</p>
				</Modal.Content>
				<Modal.Actions>
					<Button fluid onClick={onPress} color={"red"}>
						{getLabel("Done")}
					</Button>
				</Modal.Actions>
			</Modal>
		);
	}
}

export default ErrorDialog;
